const state = {
  panels: {}
}

const mutations = {
  REGISTER_PANEL(state, name) {
    if (!state.panels[name]) {
      state.panels[name] = {
        isOpen: false,
        params: null,
        conversationId: null,
        messages: []
      }
    }
  },

  OPEN_PANEL(state, { name, params }) {
    state.panels[name].isOpen = true
    state.panels[name].params = params
    state.panels[name].conversationId = params?.conversationId || null
  },

  CLOSE_PANEL(state, name) {
    if (state.panels[name]) {
      state.panels[name].isOpen = false
    }
  },

  SET_MESSAGES(state, { name, messages }) {
    state.panels[name].messages = messages
  },

  ADD_MESSAGE(state, { name, message }) {
    state.panels[name].messages.push(message)
  },

  UPSERT_MESSAGE_BY_EXECUTION_ID(state, { name, message }) {
    const messages = state.panels[name].messages
    // Match by both execution_id AND role so that the user turn (same
    // execution_id) is never accidentally overwritten with assistant content.
    const index = messages.findIndex((m) => m.execution_id === message.execution_id && m.role === message.role)

    if (index !== -1) {
      // update existing
      state.panels[name].messages[index] = {
        ...state.panels[name].messages[index],
        ...message
      }
    } else {
      // insert new
      messages.push(message)
    }
  },

  UPDATE_MESSAGE_BY_EXECUTION_ID(state, { name, executionId, message }) {
    const messages = state.panels[name].messages
    const index = findMessageIndexByExecutionId(messages, executionId)

    if (index !== -1) {
      state.panels[name].messages[index] = {
        ...state.panels[name].messages[index],
        ...message
      }
    }
  },

  RESET_PANEL(state, name) {
    if (state.panels[name]) {
      state.panels[name].messages = []
      state.panels[name].conversationId = null
      state.panels[name].params = null
    }
  }
}

const actions = {
  aiAgentChatRegisterPanel({ commit }, name) {
    commit('REGISTER_PANEL', name)
  },

  aiAgentChatOpenPanel({ commit }, { name = 'default', params }) {
    commit('OPEN_PANEL', { name, params })
  },

  aiAgentChatClosePanel({ commit }, name) {
    commit('CLOSE_PANEL', name)
  },

  aiAgentChatSetMessages({ commit }, payload) {
    commit('SET_MESSAGES', payload)
  },

  aiAgentChatAddMessage({ commit }, payload) {
    commit('ADD_MESSAGE', payload)
  },

  aiAgentChatUpsertMessage({ commit }, payload) {
    commit('UPSERT_MESSAGE_BY_EXECUTION_ID', payload)
  },

  aiAgentChatUpdateMessage({ commit }, payload) {
    commit('UPDATE_MESSAGE_BY_EXECUTION_ID', payload)
  },

  resetPanel({ commit }, name) {
    commit('RESET_PANEL', name)
  }
}

const getters = {
  aiAgentChatGetPanel: (state) => (name) => state.panels[name]
}

const findMessageIndexByExecutionId = (messages, executionId) => {
  return messages.findIndex((m) => m.execution_id === executionId)
}

export default {
  state,
  mutations,
  actions,
  getters
}
